import TemplateGallery from "../../commonComponents/CC_templateGallery";
import SnippetsGrid from '../../components/snippetsGrid';
import { Link } from "react-router-dom";
import {linkStyle} from "../../components/helpersStyles";
import { IconButton, Tooltip } from '@mui/material';
import { Icon as Iconify } from '@iconify/react';
import { CcCreateNewSnippet, CcSubSectionTitle, CcTitle } from '../../commonComponents/styledTexts';

export default function ProductHomeClickCounter() {
    return <div>
            <CcTitle>
                Click Counters
            </CcTitle>
            <div className="text-ccColorDarkTeal">Introduce social proof, brand trust and a sense of urgency into the inbox by showing click counters over key content.</div>
            <Link to={`/workflow/6`} style={linkStyle}> 
                <CcCreateNewSnippet className="mt-4" >Create Click Counter</CcCreateNewSnippet>
            </Link>
            <div className=" mt-3 border border-gray-300 rounded-md p-1 flex flex-col gap-2">
                <CcSubSectionTitle>Start with existing Template</CcSubSectionTitle>
                <div>
                <TemplateGallery productTypeId={6} />
                </div>
            </div>

            <CcSubSectionTitle className=" mt-6">Latest Click Counters Elements</CcSubSectionTitle>
            <SnippetsGrid productTypeId={6}
                 //editCall={(id, typeId) => editSnippet(id, typeId)}
             />

    </div>
}